import { Calendar2, Degree2 } from "@/components/Svg";
import CDatePicker from "@/components/main/form/CDatePicker";
import CInput from "@/components/main/form/CInput";
import CNumberInput from "@/components/main/form/CNumberInput";
import CSelect from "@/components/main/form/CSelect";
import SectorsInput from "@/components/web/main/inputComponents/SectorsInput";
import { Button, CloseButton, Modal } from "@mantine/core";
import { IconLocation, IconMapPin, IconStackPop } from "@tabler/icons-react";
import Degrees from "@/resources/degrees.json";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import OrganizationsInput from "@/components/web/main/inputComponents/OrganizationsInput";
import ServiceInput from "../inputComponents/ServiceInput";
import ServicesInput from "../inputComponents/ServicesInput";
import CompanyTypeInput from "../inputComponents/CompanyTypeInput";
import CompanySizeInput from "../inputComponents/CompanySizeInput";
import FinancingAgenciesInput from "../inputComponents/FinancingAgenciesInput";
import CountriesInput from "../inputComponents/CountriesInput";

const OrganizationsAdvancedSearchModal = ({
  show,
  setShow,
  dictionary,
  onApply,
  values,
}) => {
  const form = useForm({
    initialValues: { location: "", sectors: [] },
  });

  useEffect(() => {
    form.setValues(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);
  const [hasSearch, setHasSearch] = useState(false);
  const resetSearch = () => {
    form.reset();
    form.resetTouched();
    if (hasSearch) {
      onApply({});
    }
    setHasSearch(false)
  }


  return (
    <Modal
      centered
      overlayProps={{ blur: 5 }}
      lockScroll={true}
      opened={show}
      onClose={() => {
        setShow(false);
      }}
      size={"xl"}
      withCloseButton={false}
      padding={0}
      radius={"lg"}
      styles={{ content: { overflowY: "unset !important" } }}
    >
      <div className="bg-primaryOpacity py-4 px-5 flex items-center">
        <h4 className="my-0 ms-3 text-greyDark text-lg">
          {dictionary.advancedSearch}
        </h4>
        <CloseButton
          size={"md"}
          className="ms-auto"
          onClick={() => {
            setShow(false);
          }}
        />
      </div>
      <div className="p-8 py-6">
        <div className="md:flex md:space-x-4">
          <div className="w-full">
            <CInput
              icon={<IconMapPin />}
              className={"mt-3"}
              placeholder={dictionary.location}
              {...form.getInputProps("location")}
            />
          </div>
          <div className="w-full">
            <SectorsInput
              form={form}
              dictionary={dictionary}
              creatable={false}
            />
          </div>
        </div>
        <div className="md:flex md:space-x-4">
          <div className="w-full">
            <CompanyTypeInput
              form={form}
              dictionary={dictionary}
              creatable={false}
              clearable={true}
            />
          </div>
          <div className="w-full">
            <CompanySizeInput
              form={form}
              dictionary={dictionary}
              clearable={true}
            />
          </div>
        </div>
        <div className="md:flex md:space-x-4">
          <div className="w-full">
            <ServicesInput form={form} dictionary={dictionary} />
          </div>
          <div className="w-full">

            <CountriesInput form={form} placeholder={dictionary.CountriesOfExperiance} />
          </div>
        </div>
        <div className="md:flex md:space-x-4">
          <div className="w-full">
            <FinancingAgenciesInput form={form} dictionary={dictionary} />
          </div>
        </div>
        <div className="flex">
          <div className="ms-auto space-x-3 mt-5">
            <Button
              variant="outline"
              onClick={() => resetSearch()}
            >
              {dictionary.clear}
            </Button>
            <Button
              variant="gradient"
              onClick={() => {
                setHasSearch(true)
                onApply(form.values);
                setShow(false);
              }}
            >
              {dictionary.apply}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OrganizationsAdvancedSearchModal;
